import playerGroup from './playerGroupReducer';

export default {
  playerGroup
};
